import React from "react";

const Footer = () => (
  <footer className="site-footer">
    <small>© 2026 Reh Dogg Games Plus</small>
  </footer>
);

export default Footer;
